var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"lg4":"","md6":"","sm8":""}},[_c('h1',[_vm._v("準備中")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }